import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-vrt-finalise-dialog',
  standalone: false,
  template: `
    <h2 mat-dialog-title>Finalise VRT Map</h2>
    <mat-dialog-content>
      <p style="margin-bottom: 16px;">You are about to finalise <strong>{{ data.mapName }}</strong>.</p>
      
      <div style="background: #fff3cd; border: 1px solid #ffc107; border-radius: 4px; padding: 16px; margin-bottom: 16px;">
        <p style="margin: 0; font-size: 13px; line-height: 1.6;">
          <strong>Indemnification Notice:</strong> This VRT map is based solely on your input and does not constitute 
          a recommendation made by the platform. The platform accepts no liability for any errors, omissions, 
          or outcomes arising from the use of this map. By finalising, you acknowledge that you have reviewed 
          the map and accept full responsibility for its application.
        </p>
      </div>

      <mat-checkbox [(ngModel)]="acknowledged" color="primary">
        I acknowledge and accept the above indemnification terms
      </mat-checkbox>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>Cancel</button>
      <button mat-flat-button color="primary" [disabled]="!acknowledged" (click)="confirm()">Finalise</button>
    </mat-dialog-actions>
  `
})
export class VrtFinaliseDialogComponent {
  acknowledged = false;

  constructor(
    public dialogRef: MatDialogRef<VrtFinaliseDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { mapName: string }
  ) {}

  confirm() {
    this.dialogRef.close({ confirmed: true });
  }
}
